/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { getRequest, putRequest } from "utils/request"
import { CircularProgress } from "@material-ui/core"

import { i18n } from "../../../../translate/i18n"
import { useModal } from "hooks/modal"
import { InstagramLoginButton } from "./components"

export default function TabWhatsapp({ companyData, handleGoBack }) {
  const [loading, setLoading] = useState(false)
  const [BotId, setBotId] = useState("")
  const [bot, setBot] = useState(false)
  const [bots, setBots] = useState([])
  const { toggleHelperId } = useModal()

  const loadInstagramToken = async () => {
    setLoading(true)
    getRequest(`/bots?companyId=${companyData.id}&onlyActive=1`).then(function (
      response
    ) {
      setBots(response.data)
      setLoading(false)
    })
    const ReturnGet = await getRequest(
      `/companieschannels/settings/instagram?CompanyId=${companyData.id}`
    )
    if (ReturnGet.success) {
      // setToken(ReturnGet.data.token)
      // setEndpoint(ReturnGet.data.endPoint)
      if (ReturnGet.data.BotId) {
        setBotId(ReturnGet.data.BotId)
        setBot(true)
      }
    }
    setLoading(false)
  }

  useEffect(() => {
    loadInstagramToken()
  }, [companyData])

  const handleSave = () => {
    setLoading(true)
    putRequest(`/companieschannels/settings/instagram`, {
      CompanyId: companyData.id,
      BotId: BotId ? Number(BotId) : null,
    }).then(function (response) {
      setLoading(false)
      handleGoBack()
    })
  }

  useEffect(() => {
    if (bot === false) {
      setBotId("")
    }
  }, [bot])

  useEffect(() => {
    toggleHelperId(25)
  }, [])

  return (
    <div style={{ minHeight: 300 }}>
      <div className="title-helper-container" style={{ marginBottom: 10 }}>
        <h3>{companyData.nickName}</h3>
      </div>
      <h3>INSTAGRAM</h3>
      {!loading ? (
        <form
          className="form-edit"
          onSubmit={(e) => {
            e.preventDefault()
            handleSave()
          }}
        >
          <div className="form-group col-md-12">
            <div style={{ height: "50vh" }}>
              <InstagramLoginButton />

              <div style={{ marginTop: 10 }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={bot}
                    onChange={(value) => {
                      setBot(value.target.checked)
                    }}
                  />
                  <label style={{ marginLeft: 5 }} className="col-form-label">
                    {i18n.t("attendanceBot")}:
                  </label>
                </div>
                {bot && (
                  <div className="form-bot">
                    <select
                      className="select2 form-control select2-multiple"
                      style={{
                        width: 200,
                      }}
                      required={bot === true}
                      value={BotId || ""}
                      onChange={(e) => setBotId(e.target.value)}
                    >
                      {bots.length > 0 ? (
                        <>
                          <option value="">{i18n.t("chooseOne")}</option>

                          {bots.map((bot) => {
                            return (
                              <option key={bot.id} value={bot.id}>
                                {bot.description}
                              </option>
                            )
                          })}
                        </>
                      ) : (
                        <option value="">{i18n.t("doesNotHaveBot")}</option>
                      )}
                    </select>
                  </div>
                )}
              </div>
            </div>
            <div
              className="button-list mt-3 pull-right"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignSelf: "flex-end",
              }}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => handleGoBack()}
              >
                <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                {i18n.t("getBack")}
              </button>
              <button type="submit" className="btn btn-outline-success">
                <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                {i18n.t("save")}
              </button>
            </div>
          </div>
        </form>
      ) : (
        <div className="area-loading">
          <CircularProgress />
        </div>
      )}
    </div>
  )
}
